import Cookies from 'js-cookie';
import React, { Suspense, useEffect, useRef } from 'react'
import { useParams } from "react-router-dom";
import './IframeViewer.css'

function IframeViewer({ planId, models, modelsZipUrls }) {
  const { id } = useParams();
  return (
    <Suspense fallback={<></>}>
      <Iframe
        planId={planId}
        userId={id}
        models={models}
        modelsZipUrls={modelsZipUrls}
      />
    </Suspense>
  );
}

const Iframe = ({planId, userId, models, modelsZipUrls}) => {
  const iframeRef = useRef(null);
  let loadingMessage = "Your new smile's waiting for you. Watch it change, from start to finish."

  useEffect(() => {
    const handleReady = (event) => {
      if (
        event.data?.type === 'viewer-ready' &&
        iframeRef.current &&
        event.source === iframeRef.current.contentWindow
      ) {
        const accessToken = Cookies.get('access_token_clinic');
        iframeRef.current.contentWindow.postMessage(
          { accessToken, planId, loadingMessage, userId, models, modelsZipUrls },
          process.env.REACT_APP_VIEWER_LINK
        );
      }
    };

    window.addEventListener('message', handleReady);
    return () => window.removeEventListener('message', handleReady);
  }, [planId, userId, models, modelsZipUrls]);
  
    return (<iframe
      src={process.env.REACT_APP_VIEWER_LINK}
      ref={iframeRef}
      width="100%"
      height="100%"
      style={{ border: 'none' }}
      className='threed-iframe'
      allowFullScreen
    />)
};
  

export default IframeViewer
